const formCurrencySelection = (() => {
    // To add, modify or delete currencies in the form, edit the radio input fields within the fieldset #currency-selection
    const fieldset = document.getElementById('currency-selection');
    const radios = fieldset.querySelectorAll('input');
    const values = document.querySelectorAll('.transaction-volume span');

    let currencies = [];
    radios.forEach((radio) => currencies.push(radio.value));

    const currencyRegex = new RegExp(`[${currencies.join('')}]`, 'g');

    radios.forEach((el) => {
        el.addEventListener('change', (ev) => {
            values.forEach((v) => v.innerHTML = v.innerHTML.replaceAll(currencyRegex, ev.target.value));
        });
    });
})();

export default formCurrencySelection;
